import { BadgeInterface } from 'interfaces/company.interface';
import { CompanyRankingInterface } from 'interfaces/company-ranking.interface';

export enum BadgeType {
    NORMAL = 'normal',
    RANKING = 'ranking',
    SSK = 'ssk',
    CREDIBLE = 'credible'
}

interface BadgeBaseInterface {
    src: string;
    alt: string;
    className: string;
}

interface BadgeOtherInterface extends BadgeBaseInterface {
    type: BadgeType.SSK | BadgeType.CREDIBLE;
}

interface BadgeNormalInterface extends BadgeBaseInterface {
    type: BadgeType.NORMAL;
    item?: BadgeInterface;
}

interface BadgeRankingInterface extends BadgeBaseInterface {
    type: BadgeType.RANKING;
    item: CompanyRankingInterface;
}

export type BadgePropsInterface = BadgeOtherInterface | BadgeNormalInterface | BadgeRankingInterface;
